import { useI18n } from '@platform/i18n';
import { useCallback, useContext } from 'react';
import { CalendarContext } from './calendar/calendar-context';

/** Only real instants. Date-only filters and projected calendar wall dates keep their existing formatter. */
export function useInstantFormat(explicitTimeZone?: string | null) {
  const { formatDate } = useI18n();
  const calendar = useContext(CalendarContext);
  const timeZone = explicitTimeZone ?? calendar?.settings.displayTimeZone;
  return useCallback((value: Date | string, options: Intl.DateTimeFormatOptions = { dateStyle: 'medium', timeStyle: 'short' }) =>
    formatDate(value, { ...options, ...(timeZone && !options.timeZone ? { timeZone } : {}) }), [formatDate, timeZone]);
}
